// Exposing all callables to the client

export { callables as presentations } from "./presentations/callables";
